export enum EnvironmentVariablesComponentMode {
  Create = 'create',
  Edit = 'edit'
}
